import "./home.css";
import RecordHalf from "../../components/recordHalf/RecordHalf";
import RecordLine from "../../components/recordLine/RecordLine";
import { RecordBox } from "../../components/recordBox/RecordBox";

import { ReactComponent as ErrorIcon } from "../../assets/error.svg";
import { ReactComponent as GoodIcon } from "../../assets/good.svg";
import { ReactComponent as GreyIcon } from "../../assets/grey-icon.svg";
import { ReactComponent as WaitingIcon } from "../../assets/waiting-for-approval.svg";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { isEmpty } from "lodash";

const HomePage = () => {
  const user = useSelector(state => state.user);
  const myObligations = useSelector(state => state.obligations.obligations);

  //set closed to expire obligations as component state
  const [closeToExpire, setCloseToExpire] = useState([]);
  //set expired obligations as component state
  const [expired, setExpired] = useState([]);
  //set inforce obligations array as component state
  const [inforce, setInforce] = useState([]);

  const numberOfLessObligationsToShow = 2;

  //fetch obligations from the database and store them in the state
  useEffect(() => {
        const closeToExpireArray = [];
        const expiredArray = [];
        const inForceArray = [];

        if (!isEmpty(myObligations)) myObligations.forEach(o => {
          const dueDate = new Date(o.dueDate);
          const inForceDate = new Date(o.inForceDate);
          const now = new Date();
          const futureDate = new Date(now.getTime() + 15 * 24 * 60 * 60 * 1000);

          if (o.dueDate && dueDate < now && o.assessment !== "Compliant") {
            // expired and not compliant go to EXPIRED
            expiredArray.push(o);
          } else if (o.dueDate && inForceDate < now && dueDate < futureDate && dueDate >= now) {
            //close to expire but not yet expired go to CLOSE TO EXPIRE
            closeToExpireArray.push(o);
          } else if (o.dueDate && inForceDate < now) {
            //compliant expired and all the rest go to WHAT'S NEW
            inForceArray.push(o);
          }
        });

        // Sort inForceArray based on createdAt in descending order
        inForceArray.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        // Sort closeToExpireArray based on dueDate in ascending order
        closeToExpireArray.sort(
          (a, b) => new Date(a.dueDate) - new Date(b.dueDate)
        );

        setCloseToExpire(closeToExpireArray);
        setExpired(expiredArray);
        setInforce(inForceArray);
  }, [myObligations]);

  // const countCompliantTasks = (itemList) => itemList.filter(item => item.assessment === "Compliant").length;
  // const countPartialTasks = (itemList) => itemList.filter(item => item.assessment === "Partially").length;
  // const countNonCompliantTasks = (itemList) => itemList.filter(item => item.assessment === "Non-Compliant").length;

  const countCompletedTasks = itemList =>
    itemList && itemList.filter(item => item.action === "Completed").length;
  const countPendingTasks = itemList =>
    itemList && itemList.filter(item => item.assessment === "Pending").length;
  const countCompliantTasks = itemList =>
    itemList && itemList?.filter(item => item.assessment === "Compliant").length;
  const countPartialTasks = itemList =>
    itemList && itemList.filter(item => item.assessment === "Partially").length;
  const countNonCompliantTasks = itemList =>
    itemList && itemList.filter(item => item.assessment === "Non-Compliant").length;

  return (
    <div>
      <div id="home-simple-page" className="home">
        <div className="homeContainer">
          {/* <h1 className="homeTitle">This is the home page</h1>
          <RecordSimple /> */}
          <div className="leftArea" id="home-page-left-area" flex={2}>
            <RecordBox
              title="Close to Expire"
              id="close-to-expire"
              obligations={closeToExpire}
              user={user}
              numberOfLessObligationsToShow={numberOfLessObligationsToShow}
            />
            <RecordBox
              title="Expired"
              id="expired"
              obligations={expired}
              user={user}
              numberOfLessObligationsToShow={numberOfLessObligationsToShow}
            />
            <RecordBox
              title="What's New"
              id="what-is-new"
              obligations={inforce}
              user={user}
              numberOfLessObligationsToShow={numberOfLessObligationsToShow}
            />
          </div>
          <div
            className="rightArea"
            id="home-page-right-area"
            flex={1}
            style={{ paddingBottom: "2rem" }}
          >
            {/* <TotalCompliance
              score={
                obligations && !isEmpty(obligations)
                  ? obligations.length !== 0
                    ? (
                        countCompliantTasks(obligations) / obligations.length
                      ).toFixed(2)
                    : 0
                  : 0
              }
            /> */}
            <h2
              className="my-tasks"
              id="home-page-my-tasks"
              style={{
                color: "#333"
              }}
            >
              My Tasks
            </h2>
            <div className="one-half">
              <RecordLine
                number={countCompletedTasks(myObligations)}
                icon={<GoodIcon />}
                numberColor="#58AB5C"
                // percentage={myObligations.length !== 0 ? (myObligations.length-countCompliantTasks(myObligations))*100/myObligations.length : "NaN"}
                // percentageText="remaining to complete target"
                firstLine="Actions"
                secondLine="Completed"
                // thirdLine="this month"
                secondNumber={myObligations && myObligations.length}
                actions={true}
              />
            </div>
            <div className="two-halfs" id="home-page-two-haljs">
              <RecordHalf
                id="home-page-record-half-2"
                number={countPendingTasks(myObligations)}
                icon={<GreyIcon />}
                numberColor="grey"
                // percentage={myObligations.length !== 0 ? countCompliantTasks(myObligations)*100/myObligations.length : 0}
                // percentageText="of target achieved"
                firstLine="Pending"
                secondLine="Tasks"
                // thirdLine="this month"
              />
              <RecordHalf
                number={countNonCompliantTasks(myObligations)}
                icon={<ErrorIcon />}
                numberColor="#b00020"
                // percentage={myObligations.length !== 0 ? (myObligations.length-countCompliantTasks(myObligations))*100/myObligations.length : "NaN"}
                // percentageText="remaining to complete target"
                firstLine="Non-Compliant"
                secondLine="Tasks"
                // thirdLine="this month"
              />
            </div>
            <div
              className="two-halfs"
              id="home-page-two-halfs-2"
              style={{ marginTop: "1.25rem" }}
            >
              <RecordHalf
                id="home-page-record-half-1"
                number={countPartialTasks(myObligations)}
                icon={<WaitingIcon />}
                numberColor="#E78F0B"
                // percentage={96}
                // percentageText="of target achieved"
                firstLine="Partially Compliant"
                secondLine="Tasks"
                // thirdLine="this month"
              />
              <RecordHalf
                id="home-page-record-half-2"
                number={countCompliantTasks(myObligations)}
                icon={<GoodIcon />}
                numberColor="#58AB5C"
                // percentage={myObligations.length !== 0 ? countCompliantTasks(myObligations)*100/myObligations.length : 0}
                // percentageText="of target achieved"
                firstLine="Compliant"
                secondLine="Tasks"
                // thirdLine="this month"
              />
            </div>
            {/* <RecordSimple />
            <RecordSimple />
            <RecordSimple />
            <RecordSimple />
            <LinkButton text="Go to my Tasklist" /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
